export default __webpack_public_path__ + "static/media/secure.e53de41e.svg";